import BreadcrumbHeader from 'layout/BreadcrumbsHeader'
// import VideoReelPlayer from "views/pitch-reels/VideoReelPlayer/index";
import VideoReelPlayer from "views/pitch-reels/components/VideoReelPlayer";
import React from 'react'
import ThemeBGWrapper from 'ui-components/ThemeBGWrapper';
import { Box } from '@mui/material';

const PitchReels = ({value}) => {
  // return (
  //   <ThemeBGWrapper>
  //     <BreadcrumbHeader sx={{
  //       paddingBottom: "0rem !important"
  //     }} />
  //     <Box sx={{
  //       position: "relative"
  //     }}>
  //       <VideoReelPlayer />
  //     </Box>
  //   </ThemeBGWrapper>
  // )
  return  <VideoReelPlayer value={value} />
}

export default PitchReels